import React from 'react';
import { useSelector } from 'react-redux';

import GenericFilters from '../generic-filters/GenericFilters';
import CustomMessageButton from './custom-message-button/CustomMessageButton';
import { useProject } from '../../../context/ProjectContext';
import { PROJECT_VARIANTS } from '../../../constants';

function GenerateFilters({ onSort, sort }) {
  const messages = useSelector((state) => state.genie.messages);
  const projectName = useSelector((state) => state.genie.projectName);
  const isFormLoading = useSelector((state) => state.genie.isFormLoading);
  const { projectVariant } = useProject();

  return (
    <GenericFilters
      messages={messages}
      projectName={projectName}
      exportContext='generated'
      onSort={onSort}
      sort={sort}
      isDisabled={isFormLoading}
      AdditionalButtons={projectVariant === PROJECT_VARIANTS.ADMIN ? CustomMessageButton : null}
    />
  );
}

export default GenerateFilters;
